import { render, staticRenderFns } from "./table-cell-item.vue?vue&type=template&id=590e3326&scoped=true&"
import script from "./table-cell-item.vue?vue&type=script&lang=js&"
export * from "./table-cell-item.vue?vue&type=script&lang=js&"
import style0 from "./table-cell-item.vue?vue&type=style&index=0&id=590e3326&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "590e3326",
  null
  
)

export default component.exports